import gql from 'graphql-tag'

const cinema = gql`
    fragment cinema on CinemaType {
        id
        parent {
            name
            image
            published
            helpContent
            helpContentType
            slug
        }
        movies(first: $first, search: $search) {
            edges {
                node {
                    id
                    title
                    subtitle
                    embeddedUrl
                    published
                    order
                    imageThumbnail
                    published
                    cinema {
                        id
                    }
                    tags {
                        id
                        text
                        color
                    }
                }
            }
        }
    }
`

export const videosQuery = gql`
    query getVideos($eventId: EventID!, $first: Int, $search: String) {
        event(id: $eventId) {
            cinemas {
                edges {
                    node {
                        ...cinema
                    }
                }
            }
        }
    }
    ${cinema}
`

export const tagsQuery = gql`
    query movieTags($eventId: EventID!) {
        event(id: $eventId) {
            movieTags {
                id
                text
                color
                order
                category {
                    id
                    text
                    order
                }
            }
        }
    }
`

export const categoriesQuery = gql`
    query movieTagCategories($eventId: EventID!) {
        event(id: $eventId) {
            movieTagCategories {
                id
                order
                text
            }
        }
    }
`
